import { h } from 'preact';
import { StreamingCursor } from '../StreamingCursor';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'StreamingCursor',
  category: '🏷️ Badges & Indicadores',
  description: 'Cursor piscante durante streaming de resposta',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ fontSize: 14 }}>
      Gerando resposta<StreamingCursor />
    </div>
  ),
};
